<div class="row shopping-cart-items-table d-flex flex-wrap mt-4">
  <div class="table-wrapper col-md-12 d-flex">
    <div class="column d-flex">
      <div class="titles-row">
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.Measurements' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.Depth' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.Table' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.CrownHeight' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.CrownAngle' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.FluorescenceIntesity' | translate }}</p>
      </div>
      <div class="values-row">
        @if (diamondDetails?.measurements) {
          <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.measurements + ' mm'}}</p>
        } @else {
          <p class="font-13 text-muted py-1 mb-0">-</p>
        }
        @if (diamondDetails?.totalDepth) {
          <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.totalDepth + '%'}}</p>
        } @else {
          <p class="font-13 text-muted py-1 mb-0">-</p>
        }
        @if (diamondDetails?.tableWidth) {
          <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.tableWidth + '%'}}</p>
        } @else {
          <p class="font-13 text-muted py-1 mb-0">-</p>
        }
        @if (diamondDetails?.crownHeight) {
          <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.crownHeight + '%'}}</p>
        } @else {
          <p class="font-13 text-muted py-1 mb-0">-</p>
        }
        @if (diamondDetails?.crownAngle) {
          <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.crownAngle + '%'}}</p>
        } @else {
          <p class="font-13 text-muted py-1 mb-0">-</p>
        }
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.fluorescenceIntensity || '-'}}</p>
      </div>
    </div>
    <div class="column ml-5 d-flex">
      <div class="titles-row">
        <p class="font-14 font-weight-bold py-1 mb-0 first">{{ 'Labels.DiamondDetails.Fluorescence' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.PavilionDepth' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.PavilionAngle' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.CuletSize' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.CuletCondition' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.Girdle' | translate }}</p>
      </div>
      <div class="values-row">
        <p class="font-14 text-muted py-1 mb-0 first">{{diamondDetails?.fluorescenceColor || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.pavilionDepth || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.pavilionAngle || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.culetSize || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.culetCondition || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.girdle || '-'}}</p>
      </div>
    </div>
    <div class="column ml-5 d-flex">
      <div class="titles-row-last">
        <p class="font-14 font-weight-bold py-1 mb-0 first">{{ 'Labels.DiamondDetails.Shade' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.Milky' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.BlackInclusion' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0">{{ 'Labels.DiamondDetails.EyeClean' | translate }}</p>
        <p class="font-14 font-weight-bold py-1 mb-0 empty"></p>
      </div>
      <div class="values-row-last">
        <p class="font-14 text-muted py-1 mb-0 first">{{diamondDetails?.shade || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.milky || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.blackInclusion  || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0">{{diamondDetails?.eyeClean || '-'}}</p>
        <p class="font-14 text-muted py-1 mb-0 empty"></p>
      </div>
    </div>
  </div>

</div>